import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {getCurrentLayout} from "../../appLayout";
import Analytics from "../../../analytics";
import {getFeatureGroupName} from "../../../misc/helpers";

class MobileParentNavigationItems extends Component {

  static propTypes = {
    onItemClick: PropTypes.func.isRequired
  };

  parentItemClick = (parentItemText) => {
    Analytics.sendClickEvent('mobile-category-clicked');
    Analytics.sendClickEvent('mobile-category-clicked-' + parentItemText);
    this.props.onItemClick(parentItemText)
  };

  render() {
    const layout = getCurrentLayout();
    const parentItems = layout.designNavigationItems(); // no params, all default

    const {intl, fabricatorData} = this.props;

    return (
      <ul className={"menu-list menu-list--2"}>
        {parentItems.map((parentItem, parentItemIndex) => {
          const style = {
            backgroundImage: `url(${parentItem.part.partThumbnail})`,//TODO
          };
          if (parentItem.part.partThumbnailSize) {
            style.backgroundSize = Math.round(parentItem.part.partThumbnailSize.split("%")[0]/1.5)+"%";
            style.backgroundPosition = "top 30% center";
          }
          if (parentItem.part.partThumbnail.includes("countertop")
            || parentItem.part.partThumbnail.includes("toilet")) {
            style.backgroundSize = "80%";
          }
          return (
            <li className="menu-list__item menu-list__item--parent"
                key={"parentMenuItem"+parentItemIndex}
                onClick={() => this.parentItemClick(parentItem.text)}>
              <div className="menu-list__item-feature" style={style}>
                <div className={"menu-list__item-feature-text"}>
                  <span className="menu-list__item-feature-text-name">
                    {getFeatureGroupName(parentItem.part, intl, fabricatorData)}
                  </span>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState
  }
};

export default injectIntl(
  connect(mapStateToProps, {})(MobileParentNavigationItems)
);


